module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('nav', {
    staticClass: "z4"
  }, [_c('div', {
    staticClass: "column--one-third"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeMenu($event)
      }
    }
  }, [_c('img', {
    staticClass: "nav__logo",
    attrs: {
      "src": "/static/images/types-of-type-horizontal.svg"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "column--one-third center relative "
  }, [_c('img', {
    staticClass: "pointer nav--button",
    attrs: {
      "src": "/static/images/nav-button.png"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "drop"
    }
  }, [(_vm.menuIsOpen) ? _c('div', {
    staticClass: "dropdown"
  }, [_c('app-menu', {
    on: {
      "select": _vm.closeMenu
    }
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "column--one-third right nav--top bold"
  }, [_c('router-link', {
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeMenu($event)
      }
    }
  }, [_vm._v("About")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-958fc8be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeader.vue
// module id = 154
// module chunks = 0